import ShapeBase from './ShapeBase';
import multivaluedAttribute from '../assets/icons/multivalued_attribute.svg';
import { svgToIcon } from '../utils/svg';
import type Shape from '../objects/Shape';

class ShapeMultivaluedAttribute extends ShapeBase {
  constructor(fabricObject: Shape) {
    super(fabricObject);

    // Set min scale to avoid drawing inner lines outside of shape
    fabricObject.minScaleLimit = (this.offset() / 100) * 2.5;
  }

  static renderIcon() {
    return svgToIcon(multivaluedAttribute);
  }

  offset() {
    return 10;
  }

  // TODO figure out exact fitting rectangle. Just need the right math
  calcTextMargin() {
    const { width: w, height: h } = this.fabricObject;

    const horizontalBound = w / 6;
    const verticalBound = h / 6;

    return {
      top: verticalBound,
      left: horizontalBound,
      right: horizontalBound,
      bottom: verticalBound,
    };
  }

  render(ctx: CanvasRenderingContext2D) {
    const obj = this.fabricObject;
    const { width: w, height: h } = obj;
    const rx = w / 2;
    const ry = h / 2;

    ctx.beginPath();
    this._setBorderDash(ctx);

    // outer circle
    ctx.ellipse(0, 0, rx, ry, Math.PI, 0, 2 * Math.PI, false);

    // move to start of inner ellipse to avoid extra drawn lines
    ctx.moveTo(-rx + this.horizontalOffset(), 0);
    ctx.ellipse(
      0,
      0,
      rx - this.horizontalOffset(),
      ry - this.verticalOffset(),
      Math.PI,
      0,
      2 * Math.PI,
      false
    );

    obj._renderPaintInOrder(ctx);
  }
}

export default ShapeMultivaluedAttribute;
